import flowRight from 'lodash/flowRight';
import { connect } from 'react-redux';
import { withCustomMetrics } from '@zocdoc-frontend-common/utils-frontend-metrics';
import { showRememberMeSelector } from '../../../config/ab/selector';
import { showLoginModal, closeLoginModal } from '../../actions/SignUpActions';
import { INITIAL_BOOKING_ROOT_KEY } from '../../constants';
import { paths } from '../../paths';
import { shouldShowLoginModal } from '../../selectors/SignUpSelector';
import { pushWithQuery } from '../../utils';
import { formatAppointmentTimeForDisplay } from '../../utils';
import buildSsoReturnUrl from '../../utils/buildSsoReturnUrl';
import { getReferrerType } from '../../utils/getReferrerType';
import SignUpPageContainer from './SignUpPageContainer';

const mapStateToProps = (state, ownProps) => {
    const bookingPage = state[INITIAL_BOOKING_ROOT_KEY];

    const loggedInUser = bookingPage.loggedInUser;

    const formattedAppointmentTime = formatAppointmentTimeForDisplay(
        bookingPage.appointmentTime,
        bookingPage.locationTimeZoneId
    );

    const returnUrl = buildSsoReturnUrl(
        ownProps?.params?.bookingId || '',
        getReferrerType()
    );

    return {
        returnUrl,
        formattedAppointmentTime,
        showRememberMe: showRememberMeSelector(state),
        locationId: bookingPage.locationId,
        loggedInUser,
        providerId: bookingPage.professionalId,
        shouldShowLoginModal: shouldShowLoginModal(state),
        signedIn: state.signInForm.signedIn,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    openLoginModal: () => dispatch(showLoginModal()),
    onCloseLoginModal: () => dispatch(closeLoginModal()),
    onSignInSuccess: () => {
        dispatch(
            pushWithQuery(
                `${paths.reviewAndBookPath}/${ownProps.params.bookingId}`
            )
        );
    },
});

export default flowRight(
    connect(mapStateToProps, mapDispatchToProps),
    withCustomMetrics({
        category: 'Booking - Sign Up',
        page: 'Booking',
        section: 'Sign Up View',
    })
)(SignUpPageContainer);
